import { useEffect, useState } from 'react';
import { useApiClient } from '@/lib/api';
import { fetchSignatureBlob } from '@/lib/case_signatures';

/**
 * Faz fetch autenticado da assinatura e retorna um object URL pronto para
 * usar como `<img src>`. Revoga a URL no cleanup. A rota /blob exige
 * autenticação no header, então não dá pra usar a URL direto em <img>.
 */
export function useSignatureBlob(caseId: string, signatureId: string | undefined): string | null {
  const client = useApiClient();
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!signatureId || !caseId) {
      setUrl(null);
      return;
    }
    const resolvedSignatureId = signatureId;
    let cancelled = false;
    let created: string | null = null;
    async function load() {
      try {
        const blob = await fetchSignatureBlob(client, caseId, resolvedSignatureId);
        if (cancelled) return;
        created = URL.createObjectURL(blob);
        setUrl(created);
      } catch {
        if (!cancelled) setUrl(null);
      }
    }
    void load();
    return () => {
      cancelled = true;
      if (created !== null) URL.revokeObjectURL(created);
    };
  }, [client, caseId, signatureId]);

  return url;
}
